import React from "react"
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import "bootstrap/dist/css/bootstrap.min.css"
import { HiOutlineClipboardCopy } from 'react-icons/hi'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import ReactComment from './ReactComment'

import "./Output.scss"

function OutputRegion ({title, region, className, model, precision}) {

  async function exportTableToClipboard(reportNode) {
    var csv = [];
    var rows = reportNode.querySelectorAll("tr");

    for (var i = 0; i < rows.length; i++) {
        var row = [], cols = rows[i].querySelectorAll("td, th");
        for (var j = 0; j < cols.length; j++)
            row.push(cols[j].innerText);

    csv.push(row.join("\t"));
    }
    await setClipboard(csv.join("\n"));
  }

  async function setClipboard(text) {
    if (typeof window !== "undefined"){
      const { ClipboardItem } = window;
      var type = "text/plain";
      var blob = new Blob([text], { type });
      var data = [new ClipboardItem({ [type]: blob })];

      await navigator.clipboard.write(data).then(
        function () {
        /* success */
        }, 
        function(err) {
            console.error('Async: Could not copy text: ', err);
        }
      );
    }
  }

  return (
    <div className={className}>
      <div className="table-wrapper">
        {/* <OutputTabs data={tabs} /> */}
        <table id={className} className={precision ? 'table-content-export' : `table-content`}>
          <thead>
            <tr className="table-title">
              <Tippy placement="right" content="Copy output to clipboard"><p><HiOutlineClipboardCopy onClick={() => exportTableToClipboard(document.getElementById(`${className}`))} className="outputClipboard"/></p></Tippy>
              <th>{title}</th>
            </tr>
            <tr>
              <th>Sector</th>
              <th>Baseline Data</th>
              <th>Economic impacts <br/>(quantity change)</th>
              <th>Economic impacts <br/>(% change)</th>
              {/* <th>Baseline Data <br/>Employment</th>
              <th>Economic impacts Employment <br/>(quantity change)</th>
              <th>Economic impacts Employment <br/> (% change)</th> */}
            </tr>
          </thead>
          <tbody className="region">
            <tr className="subtitle"><th>INDUSTRY OUTPUT</th></tr>
            <tr>
              <td>Measured in</td>
              <td>$million</td>
              <td>$million</td>
              <td>%</td>
            </tr>
            <ReactComment text=" ko foreach: {data: $root.reports.R.def[0].reptSec, as: 'sector'}" />
            <tr>
              <td data-bind="text: sector"></td>
              <ReactComment text={`ko if: ko.isObservable($root.table_a['ind']['${region}'][sector])`} />
              <td data-bind={`numericText: $root.table_a['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_a')`}></td>
              <td data-bind={`numericText: $root.table_b['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_b')`}></td>
              <td data-bind={`numericText: $root.table_c['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_c')`}></td>
              <ReactComment text="/ko" />
            </tr>
            <ReactComment text="/ko" />

            <tr className="subtitle"><th>EMPLOYMENT</th></tr>
            <tr>
              <td>Measured in</td>
              <td>
                Number of workers / jobs
                <Tippy placement="top" content="For seafood industries, employment is measured in the total number of workers while for all other industries, it is measured in the total number of both full- and part-time jobs."><p><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>
              </td>
              <td>
                Number of workers / jobs
                <Tippy placement="top" content="For seafood industries, employment is measured in the total number of workers while for all other industries, it is measured in the total number of both full- and part-time jobs."><p><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>
              </td>
              <td>%</td>
            </tr>
            <ReactComment text=" ko foreach: {data: $root.reports.R.def[0].reptSec, as: 'sector'}" />
            <tr>
              <td data-bind="text: sector"></td>
              <ReactComment text={`ko if: ko.isObservable($root.table_a['ind']['${region}'][sector])`} />
              <td data-bind={`numericText: $root.table_a['emp']['${region}'][sector], precision: $root.empPrec(${precision}, 'emp', 'table_a')`}></td>
              <td data-bind={`numericText: $root.table_b['emp']['${region}'][sector], precision: $root.empPrec(${precision}, 'emp', 'table_b')`}></td>
              <td data-bind={`numericText: $root.table_c['emp']['${region}'][sector], precision: $root.empPrec(${precision}, 'emp', 'table_c')`}></td>
              <ReactComment text="/ko" />
            </tr>
            <ReactComment text="/ko" />

            <ReactComment text={`ko if: $root.reports.R.def[2]`} />
            <tr className="subtitle"><th>VALUE ADDED</th></tr>
            <tr>
              <td>Measured in</td>
              <td>$million</td>
              <td>$million</td>
              <td>%</td>
            </tr>
            <ReactComment text="ko foreach: {data: $root.reports.R.def[2].reptSec, as: 'sector'}" />
            <tr>
              <td data-bind="text: sector"></td>
              <td data-bind={`numericText: $root.table_a['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_a')`}></td>
              <td data-bind={`numericText: $root.table_b['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_b')`}></td>
              <td data-bind={`numericText: $root.table_c['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_c')`}></td>
            </tr>
            <ReactComment text="/ko" />

            <tr className="subtitle"><th>HOUSEHOLD INCOME</th></tr>
            <tr>
              <td>Measured in</td>
              <td>$million</td>
              <td>$million</td>
              <td>%</td>
            </tr>
            <ReactComment text="ko foreach: {data: $root.reports.R.def[3].reptSec, as: 'sector'}" />
            <tr>
              <td data-bind="text: sector"></td>
              <td data-bind={`numericText: $root.table_a['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_a')`}></td>
              <td data-bind={`numericText: $root.table_b['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_b')`}></td>
              <td data-bind={`numericText: $root.table_c['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_c')`}></td>
            </tr>
            <ReactComment text="/ko" />

            <tr className="subtitle"><th>STATE AND LOCAL GOV'T REVENUE</th></tr>
            <tr>
              <td>Measured in</td>
              <td>$million</td>
              <td>$million</td>
              <td>%</td>
            </tr>
            <ReactComment text="ko foreach: {data: $root.reports.R.def[4].reptSec, as: 'sector'}" />
            <tr>
              <td data-bind="text: sector"></td>
              <td data-bind={`numericText: $root.table_a['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_a')`}></td>
              <td data-bind={`numericText: $root.table_b['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_b')`}></td>
              <td data-bind={`numericText: $root.table_c['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_c')`}></td>
              {/* <td></td>
              <td></td>
              <td></td> */}
            </tr>
            <ReactComment text="/ko" />

            <tr className="subtitle"><th>NON-SEAFOOD INDUSTRY OUTPUT</th></tr>
            <tr>
              <td>Measured in</td>
              <td>$million</td>
              <td>$million</td>
              <td>%</td>
            </tr>
            <ReactComment text=" ko foreach: {data: $root.reports.R1.def[0].reptSec, as: 'sector'}" />
            <tr>
              <td data-bind="text: sector"></td>
              <td data-bind={`numericText: $root.table_a['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_a')`}></td>
              <td data-bind={`numericText: $root.table_b['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_b')`}></td>
              <td data-bind={`numericText: $root.table_c['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_c')`}></td>
            </tr>
            <ReactComment text="/ko" /> 

            <tr className="subtitle"><th>NON-SEAFOOD INDUSTRY EMPLOYMENT</th></tr>
            <tr>
              <td>Measured in</td>
              <td>
                Number of workers / jobs
                <Tippy placement="top" content="For seafood industries, employment is measured in the total number of workers while for all other industries, it is measured in the total number of both full- and part-time jobs."><p><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>
              </td>
              <td>
                Number of workers / jobs
                <Tippy placement="top" content="For seafood industries, employment is measured in the total number of workers while for all other industries, it is measured in the total number of both full- and part-time jobs."><p><FontAwesomeIcon icon={faInfoCircle}/></p></Tippy>
              </td>
              <td>%</td>
            </tr>
            <ReactComment text=" ko foreach: {data: $root.reports.R1.def[0].reptSec, as: 'sector'}" />
            <tr>
              <td data-bind="text: sector"></td>
              <td data-bind={`numericText: $root.table_a['emp']['${region}'][sector], precision: $root.empPrec(${precision}, 'emp', 'table_a')`}></td>
              <td data-bind={`numericText: $root.table_b['emp']['${region}'][sector], precision: $root.empPrec(${precision}, 'emp', 'table_b')`}></td>
              <td data-bind={`numericText: $root.table_c['emp']['${region}'][sector], precision: $root.empPrec(${precision}, 'emp', 'table_c')`}></td>
            </tr>
            <ReactComment text="/ko" /> 

            <ReactComment text="/ko" />
            <ReactComment text={`ko ifnot: $root.reports.R.def[2]`} />
            <tr className="subtitle"><th>VALUE ADDED ($ million)</th></tr>
            <tr>
              <td>Measured in</td>
              <td>$million</td>
              <td>$million</td>
              <td>%</td>
            </tr>
            <ReactComment text="ko foreach: {data: $root.reports.R2.def[0].reptSec, as: 'sector'}" />
            <tr>
              <td data-bind="text: sector"></td>
              <td data-bind={`numericText: $root.table_a['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_a')`}></td>
              <td data-bind={`numericText: $root.table_b['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_b')`}></td>
              <td data-bind={`numericText: $root.table_c['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_c')`}></td>
            </tr>
            <ReactComment text="/ko" />
            <tr className="subtitle"><th>HOUSEHOLD INCOME ($ million)</th></tr>
            <tr>
              <td>Measured in</td>
              <td>$million</td>
              <td>$million</td>
              <td>%</td>
            </tr>
            <ReactComment text="ko foreach: {data: $root.reports.R2.def[1].reptSec, as: 'sector'}" />
            <tr>
              <td data-bind="text: sector"></td>
              <td data-bind={`numericText: $root.table_a['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_a')`}></td>
              <td data-bind={`numericText: $root.table_b['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_b')`}></td>
              <td data-bind={`numericText: $root.table_c['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_c')`}></td>
            </tr>
            <ReactComment text="/ko" />
            <tr className="subtitle"><th>STATE AND LOCAL GOV'T REVENUE ($million)</th></tr>
            <tr>
              <td>Measured in</td>
              <td>$million</td>
              <td>$million</td>
              <td>%</td>
            </tr>
            <ReactComment text="ko foreach: {data: $root.reports.R2.def[2].reptSec, as: 'sector'}" />
            <tr>
              <td data-bind="text: sector"></td>
              <td data-bind={`numericText: $root.table_a['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_a')`}></td>
              <td data-bind={`numericText: $root.table_b['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_b')`}></td>
              <td data-bind={`numericText: $root.table_c['ind']['${region}'][sector], precision: $root.empPrec(${precision}, 'ind', 'table_c')`}></td>
            </tr>
            <ReactComment text="/ko" />
            <ReactComment text="/ko" />
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default OutputRegion